import * as React from 'react';

import { autoprefixer } from '../../material-ui/autoprefixer';

import { getDoneIconColor } from './utils';

import DoneIcon from 'material-ui/svg-icons/action/done';

interface SwatchesProps {
    swatches: string[][];
    hexColor: string;
    style?: React.CSSProperties;
    dataTestIdSlug: string;
    onClick: (hexColor: string) => void;
}

export class Swatches extends React.Component<SwatchesProps, {}> {

    render() {
        const styles = this.getStyles();

        return (
            <div style={this.props.style}>
                {
                    this.props.swatches.map((swatches, index) => {
                        return (
                            <div key={index} style={styles.swatches}>
                                {
                                    swatches.map((swatchColor) => {
                                        return this.renderSwatch(
                                            swatchColor,
                                            getDoneIconColor(swatchColor)
                                        );
                                    })
                                }
                            </div>
                        );
                    })
                }
            </div>
        );
    }

    private renderSwatch = (swatchColor: string, selectedSwatchColor: string) => {
        const styles = this.getStyles();

        return (
            <div key={swatchColor} style={styles.swatchContainer}>
                <div
                    style={Object.assign(
                        {},
                        styles.swatch,
                        {
                            backgroundColor: `#${swatchColor}`,
                            cursor: 'pointer'
                        },
                        swatchColor !== 'FFFFFF'
                          ? { borderColor: 'transparent' }
                          : {}
                    )}
                    onClick={() => this.props.onClick(swatchColor)}
                    data-test-id={`color-picker-swatch-${this.props.dataTestIdSlug}-${swatchColor}`}
                />
                {
                    swatchColor === this.props.hexColor
                      ? ( <DoneIcon color={`#${selectedSwatchColor}`} style={styles.selectedSwatch} /> )
                      : null
                }
            </div>
        );
    };

    private getStyles() {
        return {
            swatch: {
                width: 40,
                height: 24,
                border: '1px solid #D9D8D8' /* TODO: Use color from some theme. */
            },
            swatchContainer: {
                width: 40,
                marginRight: 6
            },
            selectedSwatch: {
                position: 'absolute',
                marginTop: -25,
                marginLeft: 10,
                pointerEvents: 'none'
            },
            swatches: Object.assign(autoprefixer({
                display: 'flex' }), {
                marginBottom: 2
            })
        };
    }

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/components/color-picker/Swatches.tsx
 **/